(() => {
  if (window.ogRetailReady) return;
  window.ogRetailReady = true;
  const configNode = document.getElementById('og-retail-config');
  const config = configNode ? JSON.parse(configNode.textContent) : {};
  const root = (config.root || '/').replace(/\/?$/, '/');
  const key = 'origavo:favourites:v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(value);
  const readSaved = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(stored) ? [...new Set(stored.filter(validHandle))].slice(0, 80) : [];
    } catch { return []; }
  };
  let saved = readSaved();
  let requestId = 0;
  const currency = new Intl.NumberFormat(config.locale || 'nl', { style: 'currency', currency: config.currency || 'EUR' });
  const live = text => { const el = document.querySelector('[data-og-live]'); if (el) el.textContent = text; };
  const synchronize = () => {
    document.querySelectorAll('[data-og-save]').forEach(button => {
      const active = saved.includes(button.dataset.ogSave);
      button.setAttribute('aria-pressed', String(active));
      const label = active ? config.remove : config.save;
      button.setAttribute('aria-label', button.dataset.ogProductTitle ? `${label}: ${button.dataset.ogProductTitle}` : label);
      const caption = button.closest('.og-product-tools')?.querySelector('[data-og-save-label]');
      if (caption && caption.textContent !== label) caption.textContent = label;
    });
    document.querySelectorAll('[data-og-count]').forEach(el => {
      if (el.textContent !== String(saved.length)) el.textContent = String(saved.length);
      el.hidden = saved.length === 0;
    });
  };
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(saved)); } catch {} synchronize(); };
  const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text !== undefined) node.textContent = text; return node; };
  const safeImage = value => {
    if (typeof value !== 'string' || !value.trim()) return null;
    try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.origin === location.origin || u.hostname === 'cdn.shopify.com') ? u.href : null; } catch { return null; }
  };
  const renderSaved = async (restoreFocusIndex) => {
    const list = document.querySelector('[data-og-favorites-list]');
    if (!list) return;
    const current = ++requestId;
    const handles = [...saved];
    list.replaceChildren(el('p', '', handles.length ? config.loading : config.empty));
    if (!handles.length) { if (restoreFocusIndex !== undefined) document.querySelector('#og-favorites [data-og-close]')?.focus(); return; }
    const items = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return { handle, unavailable: true };
        const product = await response.json();
        if (product.handle !== handle || !product.title) return { handle, unavailable: true };
        return { handle, product };
      } catch { return { handle, unavailable: true }; }
    }));
    if (current !== requestId) return;
    const fragment = document.createDocumentFragment();
    items.forEach(({handle, product, unavailable}) => {
      const row = el('article', 'og-saved-item');
      const imageUrl = product && safeImage(product.featured_image);
      if (imageUrl) { const image = el('img'); image.src = imageUrl; image.alt = ''; image.loading = 'lazy'; row.append(image); }
      else row.append(el('span'));
      const detail = el('div');
      if (unavailable) detail.append(el('p', '', config.unavailable));
      else {
        const link = el('a', '', product.title); link.href = `${root}products/${handle}`; detail.append(link);
        if (Number.isFinite(product.price)) detail.append(el('small', '', currency.format(product.price / 100)));
        if (product.available === false) detail.append(el('small', 'og-saved-unavailable', config.soldOut));
      }
      row.append(detail);
      const remove = el('button', '', '×'); remove.type = 'button'; remove.dataset.ogRemove = handle; remove.setAttribute('aria-label', product?.title ? `${config.remove}: ${product.title}` : config.remove); row.append(remove);
      fragment.append(row);
    });
    list.replaceChildren(fragment);
    if (restoreFocusIndex !== undefined) {
      const buttons = [...list.querySelectorAll('[data-og-remove]')];
      buttons[Math.min(restoreFocusIndex, buttons.length - 1)]?.focus();
    }
  };
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const open = target.closest('[data-og-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.ogOpen);
      if (dialog instanceof HTMLDialogElement) {
        document.querySelectorAll('.og-mega[open], .og-localization[open]').forEach(d => d.open = false);
        dialog.showModal();
        if (dialog.id === 'og-favorites') renderSaved();
      }
    }
    const close = target.closest('[data-og-close]');
    if (close) close.closest('dialog')?.close();
    const save = target.closest('[data-og-save]');
    if (save && validHandle(save.dataset.ogSave)) {
      event.preventDefault(); event.stopPropagation();
      const handle = save.dataset.ogSave;
      const exists = saved.includes(handle);
      saved = exists ? saved.filter(item => item !== handle) : [handle, ...saved].slice(0, 80);
      persist(); live(exists ? config.removed : config.added);
    }
    const remove = target.closest('[data-og-remove]');
    if (remove) { const index = [...document.querySelectorAll('[data-og-remove]')].indexOf(remove); saved = saved.filter(handle => handle !== remove.dataset.ogRemove); persist(); renderSaved(index); live(config.removed); }
    if (!target.closest('.og-mega')) document.querySelectorAll('.og-mega[open]').forEach(d => d.open = false);
    if (!target.closest('.og-localization')) document.querySelectorAll('.og-localization[open]').forEach(d => d.open = false);
  }, true);
  document.querySelectorAll('.og-dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.og-mega[open],.og-localization[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-og-finder]')) return;
    event.preventDefault();
    const data = new FormData(form);
    const path = data.get('collection');
    const selectedInput = [...form.querySelectorAll('[name=collection]')].find(input => input.checked && input.value === path);
    if (!selectedInput) return;
    const destination = new URL(path, location.origin);
    if (destination.origin !== location.origin) return;
    const budget = data.get('budget');
    if (budget && /^\d+$/.test(budget)) destination.searchParams.set('filter.v.price.lte', budget);
    location.assign(destination.href);
  });
  window.addEventListener('storage', event => { if (event.key === key) { saved = readSaved(); synchronize(); if (document.getElementById('og-favorites')?.open) renderSaved(); } });
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (scheduled || !records.some(r => r.addedNodes.length)) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; synchronize(); });
  });
  observer.observe(document.body, { childList:true, subtree:true });
  synchronize();
  let merchRequest;
  let merchSequence = 0;
  document.addEventListener('shopify:cart:lines-update', async () => {
    const targets = [...document.querySelectorAll('[data-og-merch-section]')];
    if (!targets.length) return;
    const sequence = ++merchSequence;
    merchRequest?.abort(); merchRequest = new AbortController();
    targets.forEach(target => target.hidden = true);
    const url = new URL(location.href);
    url.searchParams.set('sections', targets.map(target => target.dataset.ogMerchSection).join(','));
    try {
      const response = await fetch(url, {signal:merchRequest.signal});
      if (!response.ok) return;
      const sections = await response.json();
      if (sequence !== merchSequence) return;
      targets.forEach(target => {
        const html = sections[target.dataset.ogMerchSection];
        if (typeof html !== 'string') return;
        const fresh = new DOMParser().parseFromString(html,'text/html').querySelector('[data-og-merch-section]');
        if (fresh && target.isConnected) { target.replaceChildren(...fresh.childNodes); target.hidden = false; }
      });
    } catch {}
  });
  class OgCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return; this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-og-slide]')]; this.dots = [...this.querySelectorAll('[data-og-dot]')]; this.index = 0;
      this.querySelector('[data-og-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.querySelector('[data-og-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
      this.addEventListener('keydown', event => { if (event.target.closest('.og-slide-controls') && ['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); this.dots[this.index]?.focus(); } });
      this.addEventListener('touchstart', event => { this.touch = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
      this.addEventListener('touchend', event => { if (!this.touch) return; const dx = event.changedTouches[0].clientX-this.touch.x, dy = event.changedTouches[0].clientY-this.touch.y; if (Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5) this.show(this.index + (dx<0 ? 1 : -1)); this.touch = null; }, {passive:true});
      document.addEventListener('shopify:block:select', event => { const selected = this.slides.findIndex(slide => slide.contains(event.target)); if (selected >= 0) this.show(selected); });
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.hidden = i !== this.index);
      this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      const number = this.querySelector('[data-og-slide-number]'); if (number) number.textContent = `${String(this.index+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
    }
  }
  class OgSearch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return; this.initialized = true;
      this.input = this.querySelector('input[type=search]'); this.results = this.querySelector('.og-search-results'); this.seq = 0;
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.controller?.abort(); this.seq++; this.hide(); this.results.replaceChildren(); if (this.input.value.trim().length < 2) return; this.timer = setTimeout(() => this.search(), 180); });
      this.input.addEventListener('focus', () => { if (this.results.childElementCount && this.input.value.trim().length >= 2) this.show(); });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.hide(); this.input.focus(); return; }
        if (!['ArrowDown','ArrowUp'].includes(event.key) || this.results.hidden) return;
        const links = [...this.results.querySelectorAll('a')]; if (!links.length) return;
        event.preventDefault(); const index = links.indexOf(document.activeElement); const next = event.key === 'ArrowDown' ? (index+1)%links.length : (index-1+links.length)%links.length; links[next].focus();
      });
      this.addEventListener('focusout', () => { queueMicrotask(() => { if (!this.contains(document.activeElement)) this.hide(); }); });
      this.outside = event => { if (!this.contains(event.target)) this.hide(); }; document.addEventListener('click', this.outside);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); document.removeEventListener('click', this.outside); this.initialized = false; }
    hide() { this.results.hidden = true; this.input.setAttribute('aria-expanded','false'); }
    show() { this.results.hidden = false; this.input.setAttribute('aria-expanded','true'); }
    async search() {
      const query = this.input.value.trim(); if (query.length < 2) return;
      this.controller = new AbortController(); const current = ++this.seq;
      const url = new URL(this.dataset.endpoint, location.origin);
      url.search = new URLSearchParams({q:query,'resources[type]':'product,collection','resources[limit]':'6',section_id:'og-predictive-search'}).toString();
      try {
        const response = await fetch(url, {signal:this.controller.signal}); if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text(); if (current !== this.seq || query !== this.input.value.trim()) return;
        const content = new DOMParser().parseFromString(html,'text/html').querySelector('[data-og-suggestions]');
        if (!content) throw new Error('Empty suggestions');
        this.results.replaceChildren(content); if (this.contains(document.activeElement)) this.show();
      } catch (error) {
        if (error.name === 'AbortError' || current !== this.seq) return;
        const message = el('p','',this.dataset.error); message.setAttribute('role','status'); this.results.replaceChildren(message); if (this.contains(document.activeElement)) this.show();
      }
    }
  }
  if (!customElements.get('og-carousel')) customElements.define('og-carousel',OgCarousel);
  if (!customElements.get('og-search')) customElements.define('og-search',OgSearch);
})();
